import accounting from "accounting";
import { formatAndParse } from "../../../Common/utils/universalFuntions";
import { message, Space } from "antd";

export const calculateFinalNetSheetPrice = ({td, condition}) => {
    let PurchasePrice = formatAndParse(td['PurchasePrice']);

    // Pre-Equity group
    const loanKeys = Object.keys(td).filter((key) => /^Loan\d+$/.test(key) && key !== "Loan1");
    let totalLoans = loanKeys?.reduce((acc, key) => acc + formatAndParse(td[key]), 0) || 0;

    let GrossEquity = PurchasePrice - totalLoans - formatAndParse(td['Loan1']);

    let conditionallyUpdatedFields = {}
    if (condition === "PURCHASE_PRICE_CHANGED") {
        // CHECK IF THE % FIELDS HAVE VALUES
        let ListingBrokerCommissionInPercentage = formatAndParse(td['ListingBrokerCommissionInPercentage']) || 0;
        td['ListingBrokerCommission'] = accounting.formatNumber((PurchasePrice * (ListingBrokerCommissionInPercentage / 100)), 2);
        let SellingBrokerCommissionInPercentage = formatAndParse(td['SellingBrokerCommissionInPercentage']) || 0;
        td['SellingBrokerCommission'] = accounting.formatNumber((PurchasePrice * (SellingBrokerCommissionInPercentage / 100)), 2);
        let TitlePolicyInPercentage = formatAndParse(td['TitlePolicyInPercentage']) || 0;
        td['TitlePolicy'] = accounting.formatNumber((PurchasePrice * (TitlePolicyInPercentage / 100)), 2);
        let EscrowFeeInPercentage = formatAndParse(td['EscrowFeeInPercentage']) || 0;
        td['EscrowFee'] = accounting.formatNumber((PurchasePrice * (EscrowFeeInPercentage / 100)), 2);
        let TransferTaxInPercentage = formatAndParse(td['TransferTaxInPercentage']) || 0;
        td['TransferTax'] = accounting.formatNumber((PurchasePrice * (TransferTaxInPercentage / 100)), 2);
        conditionallyUpdatedFields = {
            ListingBrokerCommission: td['ListingBrokerCommission'],
            SellingBrokerCommission: td['SellingBrokerCommission'],
            TitlePolicy: td['TitlePolicy'],
            EscrowFee: td['EscrowFee'],
            TransferTax: td['TransferTax'],
            ListingBrokerCommission: td['ListingBrokerCommission'],
            SellingBrokerCommission: td['SellingBrokerCommission'],
            TitlePolicy: td['TitlePolicy'],
            EscrowFee: td['EscrowFee'],
            TransferTax: td['TransferTax'],
        }
    }

    // Post-Equity group
    let ListingBrokerCommission = formatAndParse(td['ListingBrokerCommission']) || 0;
    let SellingBrokerCommission = formatAndParse(td['SellingBrokerCommission']) || 0;
    let TitlePolicy = formatAndParse(td['TitlePolicy']) || 0;
    let EscrowFee = formatAndParse(td['EscrowFee']) || 0;
    let TransferTax = formatAndParse(td['TransferTax']) || 0;
    let TaxService = formatAndParse(td['TaxService']) || 0;
    let HomeWarranty = formatAndParse(td['HomeWarranty']) || 0;
    let ReleaseFee = formatAndParse(td['ReleaseFee']) || 0;
    let CourierFee = formatAndParse(td['CourierFee']) || 0;

    // Pre set Items
    // let FirstMortgage = formatAndParse(td['FirstMortgage']) || 0;
    // let SecondMortgage = formatAndParse(td['SecondMortgage']) || 0;
    let TaxProration = formatAndParse(td['TaxProration']) || 0;
    let TransactionManagementFee = formatAndParse(td['TransactionManagementFee']) || 0;
    let BackTaxes = formatAndParse(td['BackTaxes']) || 0;
    let WireFees = formatAndParse(td['WireFees']) || 0;
    let DiscountPaidBySeller = formatAndParse(td['DiscountPaidBySeller']) || 0;
    let HOADues = formatAndParse(td['HOADues']) || 0;
    let HOATransferFee = formatAndParse(td['HOATransferFee']) || 0;
    let Miscellaneous = formatAndParse(td['Miscellaneous']) || 0;
    let PrepaymentPenalty = formatAndParse(td['PrepaymentPenalty']) || 0;
    let Recording = formatAndParse(td['Recording']) || 0;
    let WaterEscrow = formatAndParse(td['WaterEscrow']) || 0;

    // Blank Items
    const additionalFeeKeys = Object.keys(td).filter((key) => /^AdditionalFeeAmt\d+$/.test(key));
    let totalAdditionalFees = additionalFeeKeys?.reduce((acc, key) => acc + formatAndParse(td[key]), 0) || 0;

    // let totalPostEquityGroup = ListingBrokerCommission + SellingBrokerCommission + TitlePolicy + EscrowFee + TransferTax + TaxService + HomeWarranty + ReleaseFee + CourierFee + FirstMortgage + SecondMortgage + BackTaxes + WireFees + DiscountPaidBySeller + HOADues + HOATransferFee + Miscellaneous + PrepaymentPenalty + Recording + WaterEscrow + totalAdditionalFees + TaxProration + TransactionManagementFee;
    let totalPostEquityGroup = ListingBrokerCommission + SellingBrokerCommission + TitlePolicy + EscrowFee + TransferTax + TaxService + HomeWarranty + ReleaseFee + CourierFee + TaxProration + TransactionManagementFee + BackTaxes + WireFees + DiscountPaidBySeller + HOADues + HOATransferFee + Miscellaneous + PrepaymentPenalty + Recording + WaterEscrow + totalAdditionalFees;
    let TotalEstimateCosts = totalPostEquityGroup;

    let TotalEstimateNetProceeds = GrossEquity - TotalEstimateCosts;

    return {
        TotalEstimateNetProceeds: accounting.formatNumber(TotalEstimateNetProceeds, 2),
        GrossEquity: accounting.formatNumber(GrossEquity, 2),
        TotalEstimateCosts: accounting.formatNumber(TotalEstimateCosts, 2),
        ...conditionallyUpdatedFields,
    };
}

export const calculateNetSheetAmtWyomingSelling = ({ td, calculationFixedKeys, source }) => {
    let NetProceedsFromSale = td["NetProceedsFromSale"] || "0.00";
    let EstimatedCostOfSales = td["EstimatedCostOfSales"] || "0.00";
    let PurchasePrice = td["PurchasePrice"] || "0.00";
    if (calculationFixedKeys?.group1?.length > 0) {
        EstimatedCostOfSales = calculationFixedKeys.group1.reduce((acc, key) => {
            if (td[key] !== undefined) {
                return acc + formatAndParse(td[key]);
            }
            return acc;
        }, 0);
    }
    NetProceedsFromSale = formatAndParse(PurchasePrice) - formatAndParse(EstimatedCostOfSales);
    return {
        NetProceedsFromSale: accounting.formatNumber(NetProceedsFromSale, 2),
        EstimatedCostOfSales: accounting.formatNumber(EstimatedCostOfSales, 2),
    };
}

export const checkBrokerageFee = ({ td, source, event, specificData, needsDbUpdate }) => {
    if (source === "SET_INITIAL_VALUES")  {
        let SellingSideBrokerageFee = "0.00";
        let ListingSideBrokerageFee = "0.00";
        if (formatAndParse(td["BrokerageFee"]) === 0 || ["0", 0, "0.00", "", null, undefined].includes(td["BrokerageFee"])) {
            td = { ...td, SellingSideBrokerageFee, ListingSideBrokerageFee };
        } else if (formatAndParse(td["BrokerageFee"])) {
            if (formatAndParse(td["SellingSideBrokerageFee"]) && ["0", 0, "0.00", "", null, undefined].includes(td["ListingSideBrokerageFee"])) {
                ListingSideBrokerageFee = formatAndParse(td["BrokerageFee"]) - formatAndParse(td["SellingSideBrokerageFee"]);
            } else if (formatAndParse(td["ListingSideBrokerageFee"]) && ["0", 0, "0.00", "", null, undefined].includes(td["SellingSideBrokerageFee"])) {
                SellingSideBrokerageFee = formatAndParse(td["BrokerageFee"]) - formatAndParse(td["ListingSideBrokerageFee"]);
            }
        }
        return {
            SellingSideBrokerageFee: accounting.formatNumber(formatAndParse(td["SellingSideBrokerageFee"]), 2),
            ListingSideBrokerageFee: accounting.formatNumber(formatAndParse(td["ListingSideBrokerageFee"]), 2),
        }
    } else if (source === "HANDLE_INPUT") {
        if (!td["BrokerageFee"] || [0, "0", "0.00", "", null, undefined].includes(td["BrokerageFee"])) {
            message.error("Please enter the Brokerage Fee first.");
            event.preventDefault();
            event.target.value = "0.00";
            specificData = { ...specificData, ListingSideBrokerageFee: "", SellingSideBrokerageFee: "" };
            needsDbUpdate = true;
        } else {
            let BrokerageFee = formatAndParse(td["BrokerageFee"]);
            if (event?.target?.name === "ListingSideBrokerageFee") {
                if (formatAndParse(event.target.value) > BrokerageFee) {
                    message.error("Listing Side Brokerage Fee cannot be greater than the total Brokerage Fee.");
                    event.preventDefault();
                    if (td["SellingSideBrokerageFee"] && !["0", 0, "0.00", "", null, undefined].includes(td["SellingSideBrokerageFee"])) {
                        specificData["ListingSideBrokerageFee"] = BrokerageFee - formatAndParse(td["SellingSideBrokerageFee"]);
                    } else {
                        specificData["ListingSideBrokerageFee"] = accounting.formatNumber(0, 2);
                    }
                    return specificData;
                }
                specificData["ListingSideBrokerageFee"] = accounting.formatNumber(formatAndParse(event.target.value), 2);
                specificData["SellingSideBrokerageFee"] = accounting.formatNumber((BrokerageFee - formatAndParse(specificData["ListingSideBrokerageFee"])), 2);
            }
            if (event?.target?.name === "SellingSideBrokerageFee") {
                if (formatAndParse(event.target.value) > BrokerageFee) {
                    message.error("Selling Side Brokerage Fee cannot be greater than the total Brokerage Fee.");
                    event.preventDefault();
                    if (td["ListingSideBrokerageFee"] && !["0", 0, "0.00", "", null, undefined].includes(td["ListingSideBrokerageFee"])) {
                        specificData["SellingSideBrokerageFee"] = BrokerageFee - formatAndParse(td["ListingSideBrokerageFee"]);
                    } else {
                        specificData["SellingSideBrokerageFee"] = accounting.formatNumber(0, 2);
                    }
                    return specificData;
                }
                specificData["SellingSideBrokerageFee"] = accounting.formatNumber(formatAndParse(event.target.value), 2);
                specificData["ListingSideBrokerageFee"] = accounting.formatNumber((BrokerageFee - formatAndParse(specificData["SellingSideBrokerageFee"])), 2);
            }
        }
        return specificData;
    }
}

// 

export const calculateNetSheetAmtWyomingBuying = ({ td, calculationFixedKeys }) => {
    let dataToBeUpdated = {};
    let PurchasePrice = td["PurchasePrice"] || "0.00";
    // GROUP ONE > Purchase and Mortgage Information
    // const groupOneFixedKeys = calculationFixedKeys?.group1?.length > 0 && calculationFixedKeys.group1 || [];
    // const sumOfGroupOne = groupOneFixedKeys?.reduce((acc, key) => {
    //     return acc + (td[key] ? formatAndParse(td[key]) : 0);
    // }, 0);

    // GROUP TWO > Estimate Closing Costs
    const groupTwoFixedKeys = calculationFixedKeys?.group2?.length > 0 && calculationFixedKeys.group2 || [];
    const TotalEstimatedClosingCosts = groupTwoFixedKeys?.reduce((acc, key) => {
        return acc + (td[key] ? formatAndParse(td[key]) : 0);
    }, 0);
    dataToBeUpdated = { ...dataToBeUpdated, TotalEstimatedClosingCosts: accounting.formatNumber(TotalEstimatedClosingCosts, 2) };

    // GROUP THREE > ESTIMATED MONTHLY PAYMENT
    let FirstMortgagePrincipalAndInterest = formatAndParse(td["FirstMortgagePrincipalAndInterest"]) || 0;
    let HazardInsuranceEscrowFee = formatAndParse(td["HazardInsuranceEscrowFee"]) || 0;
    let PropertyTaxEscrowFee = formatAndParse(td["PropertyTaxEscrowFee"]) || 0;
    let MortgageInsuranceFee = formatAndParse(td["MortgageInsuranceFee"]) || 0;
    const EstimatedMonthlyPayment = accounting.formatNumber((FirstMortgagePrincipalAndInterest + HazardInsuranceEscrowFee + PropertyTaxEscrowFee + MortgageInsuranceFee), 2);
    dataToBeUpdated = { ...dataToBeUpdated, EstimatedMonthlyPayment };

    // GROUP FOUR >  Total ESTIMATED MONTHLY PAYMENT
    let SecondMortgagePrincipalAndInterest = formatAndParse(td["SecondMortgagePrincipalAndInterest"]) || 0;
    const TotalEstimatedMonthlyPayment = accounting.formatNumber((formatAndParse(EstimatedMonthlyPayment) + SecondMortgagePrincipalAndInterest), 2);
    dataToBeUpdated = { ...dataToBeUpdated, TotalEstimatedMonthlyPayment };

    // GROUP FOUR > ESTIMATED CASH NEED FOR PURCHASE
    let FirstMortgage = formatAndParse(td["FirstMortgage"]) || 0;
    let SecondMortgage = formatAndParse(td["SecondMortgage"]) || 0;
    let TotalEstimatedCashNeeded = formatAndParse(PurchasePrice) - FirstMortgage - SecondMortgage;
    dataToBeUpdated = { ...dataToBeUpdated, TotalEstimatedCashNeeded: accounting.formatNumber(TotalEstimatedCashNeeded, 2) };
    return dataToBeUpdated;
}

export const calculateMonthlyPrincipalAndInterest = ({ td, source, Principal, AnnualIntRatePercent, numberOfPaymentsToMake }) => {
    if (!Principal || !AnnualIntRatePercent || !numberOfPaymentsToMake) {
        return "0.00";
    }
    const invalidValues = ["0", 0, "0.00", "", null, undefined];
    if (invalidValues.includes(Principal) || invalidValues.includes(AnnualIntRatePercent) || invalidValues.includes(numberOfPaymentsToMake)) {
        return "0.00";
    }
    let monthlyRate = (formatAndParse(AnnualIntRatePercent) / 100) / 12;
    let numberOfPayments = formatAndParse(numberOfPaymentsToMake) * 12;
    // P* r * (1 + r)^n / ([(1 + r)^n] - 1) OR // P * (r / (1 - (1 + r)^-n))
    let monthlyPayment = (formatAndParse(Principal) * monthlyRate) / (1 - Math.pow((1 + monthlyRate), -numberOfPayments));
    return accounting.formatNumber(monthlyPayment, 2);
}

// Helper function to check if 3 fields exist
// export const canCalculate = (principal, rate, term) =>
//     principal && rate && term && !["0", 0, "0.00", "", null, undefined].includes(principal);

export const canCalculate = (principal, rate, term) => {
    const invalidValues = ["0", 0, "0.00", "", null, undefined];

    return (
        !invalidValues.includes(principal) &&
        !invalidValues.includes(rate) &&
        !invalidValues.includes(term)
    );
};

// Call principal & interest calculation
export const handleMortgageCalculation = ({ prefix, td, source }) => {
    const principal = td[`${prefix}Mortgage`];
    const rate = td[`${prefix}MortgageAnnualInterestRate`];
    const term = td[`${prefix}MortgageTermOfLoanInYears`];

    if (canCalculate(principal, rate, term)) {
        return calculateMonthlyPrincipalAndInterest({
            td,
            source: "HANDLE_INPUT",
            Principal: principal,
            AnnualIntRatePercent: rate,
            numberOfPaymentsToMake: term,
        });
    } else {
        return "0.00";
    }
};

export const calculateTheAnnualAmount = ({ td, event, source }) => {
    if (source === "HANDLE_INPUT") {
        if (event?.target?.name === "PropertyTaxEscrowForTwoMonths") {
            let TwoMonthlyAmount = formatAndParse(event.target.value);
            let AnnualAmount = TwoMonthlyAmount * 6;
            return {
                AnnualPropertyTaxEscrow: accounting.formatNumber(AnnualAmount, 2),
            }
        }
        if (event?.target?.name === "AnnualPropertyTaxEscrow") {
            let AnnualAmount = formatAndParse(event.target.value);
            let TwoMonthlyAmount = AnnualAmount / 6;
            return {
                PropertyTaxEscrowForTwoMonths: accounting.formatNumber(TwoMonthlyAmount, 2),
            }
        }
    } else if (source === "SET_INITIAL_VALUES") {
        if (["0", 0, "0.00", "", null, undefined].includes(td["PropertyTaxEscrowForTwoMonths"]) && ["0", 0, "0.00", "", null, undefined].includes(td["AnnualPropertyTaxEscrow"])) {
            return {
                PropertyTaxEscrowForTwoMonths: accounting.formatNumber(0, 2),
                AnnualPropertyTaxEscrow: accounting.formatNumber(0, 2),
            }
        } else if (td["PropertyTaxEscrowForTwoMonths"] && !td["AnnualPropertyTaxEscrow"]) {
            let TwoMonthlyAmount = formatAndParse(td["PropertyTaxEscrowForTwoMonths"]);
            let AnnualAmount = TwoMonthlyAmount * 6;
            return {
                AnnualPropertyTaxEscrow: accounting.formatNumber(AnnualAmount, 2),
            }
        } else if (td["AnnualPropertyTaxEscrow"] && !td["PropertyTaxEscrowForTwoMonths"]) {
            let AnnualAmount = formatAndParse(td["AnnualPropertyTaxEscrow"]);
            let TwoMonthlyAmount = AnnualAmount / 6;
            return {
                PropertyTaxEscrowForTwoMonths: accounting.formatNumber(TwoMonthlyAmount, 2),
            }
        }
    }
}